export default __webpack_public_path__ + "static/3-b4f0f1790548ef27f1f7608d30120363.png";